import { Award, Crown, Gem, Medal, Trophy } from "lucide-react";
import { cn } from "@/lib/utils";

export type HustleLevel = "Bronze" | "Silver" | "Gold" | "Platinum" | "Black";

const STYLES: Record<HustleLevel, { bg: string; text: string; ring: string; Icon: typeof Award }> = {
  Bronze:   { bg: "bg-[hsl(28_55%_45%/0.18)]",  text: "text-[hsl(28_70%_38%)]",   ring: "ring-[hsl(28_55%_45%/0.35)]",  Icon: Medal },
  Silver:   { bg: "bg-[hsl(220_10%_70%/0.22)]", text: "text-[hsl(220_10%_38%)]",  ring: "ring-[hsl(220_10%_60%/0.4)]",  Icon: Award },
  Gold:     { bg: "bg-[hsl(45_90%_55%/0.22)]",  text: "text-[hsl(38_85%_38%)]",   ring: "ring-[hsl(45_85%_55%/0.45)]",  Icon: Trophy },
  Platinum: { bg: "bg-[hsl(190_55%_85%/0.35)]", text: "text-[hsl(195_50%_30%)]",  ring: "ring-[hsl(190_50%_60%/0.45)]", Icon: Gem },
  Black:    { bg: "bg-foreground/10",            text: "text-foreground",          ring: "ring-foreground/30",           Icon: Crown },
};

interface Props {
  level: HustleLevel | string;
  score?: number;
  size?: "sm" | "md";
  showScore?: boolean;
  className?: string;
}

export const HustleBadge = ({ level, score, size = "sm", showScore = false, className }: Props) => {
  const key = (["Bronze","Silver","Gold","Platinum","Black"].includes(level) ? level : "Bronze") as HustleLevel;
  const s = STYLES[key];
  const sizing = size === "md"
    ? "px-3 py-1.5 text-sm gap-1.5"
    : "px-2 py-0.5 text-[11px] gap-1";
  const iconSize = size === "md" ? "h-4 w-4" : "h-3 w-3";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold ring-1",
        s.bg, s.text, s.ring, sizing, className
      )}
      title={score !== undefined ? `Hustle Score: ${score}` : undefined}
    >
      <s.Icon className={iconSize} />
      <span>{key}</span>
      {showScore && score !== undefined && (
        <span className="opacity-70 font-normal">· {score}</span>
      )}
    </span>
  );
};
